module.exports = fox._r("images/404-new.png", __webpack_public_path__ + "_/_/_/common/frame/images/404-new.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/404-new.png
// module id = 117
// module chunks = 2